import { useState, type FormEvent } from 'react';
import { login } from '../lib/auth';

interface LoginScreenProps {
  onLogin: () => void;
}

export default function LoginScreen({ onLogin }: LoginScreenProps) {
  const [passcode, setPasscode] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(false);
    setLoading(true);

    try {
      const success = await login(passcode);
      if (success) {
        onLogin();
      } else {
        setError(true);
        setPasscode('');
      }
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <h1 className="login-title">مام‌لینگو</h1>
        <p className="login-subtitle">لطفاً رمز ورود را وارد کنید</p>

        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="password"
            className="login-input"
            dir="ltr"
            placeholder="••••••"
            value={passcode}
            onChange={(e) => {
              setPasscode(e.target.value);
              setError(false);
            }}
            autoComplete="current-password"
            autoFocus
          />

          {error && (
            <p className="login-error">رمز اشتباه است</p>
          )}

          <button
            type="submit"
            className="login-button"
            disabled={loading || passcode.length === 0}
          >
            {loading ? '...' : 'ورود'}
          </button>
        </form>
      </div>
    </div>
  );
}
